import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
// import Grid from '@nubank/nuds-web/components/Grid/Grid';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';
import ReactHtmlParser from 'react-html-parser'; 

// import Section from 'components/structure/Section';
import Block from './components/structure/Block/Block.js';

const questions = [
{
  intlKey: 'faq1',
  question: 'Quais as datas do Processo Seletivo?',
  answer: 'Inscrições: De 11 até 18 de março<br/>Testes Online: Entre 25 março e 01 de abril<br/>  Dinâmica em grupo: Entre 16 e 24 de abril<br/>  Entrevistas: Entre 30 de abril e 22 de maio<br/>  Você receberá por e-mail informações complementares a cada etapa do processo seletivo.' 
},
{
  intlKey: 'faq2',
  question: 'Como funcionarão as etapas do Processo Seletivo?',
  answer: 'O processo seletivo será composto por 4 etapas, que são eliminatórias. Cada uma delas possui o objetivo de avaliar alguma habilidade ou comportamento necessário para a área escolhida: <ul><li > • Inscrições;</li><li > • Testes Online: Após a inscrição, todas as pessoas candidatas receberão um teste online, que deverá ser concluído dentro do período de tempo estipulado e comunicado por e-mail; </li><li > • Dinâmica em grupo: Essa etapa não será uma competição, mas um momento de colaboração em um exercício que simula o dia a dia do Nubank relacionado às áreas específicas. </li><li > • Entrevistas: Todas as entrevistas serão 100% online e abordarão tópicos de carreira, além de aprofundamentos técnicos, caso necessário. </li></ul >Os detalhes de cada etapa dependerão da área de interesse escolhida no momento da inscrição, podendo ter diferenças nos tipos de testes e exercícios. Você receberá mais informações por e-mail.'
},
{
  intlKey: 'faq3',
  question: 'Posso escolher mais de uma área de interesse?',
  answer: 'No momento da inscrição você deve indicar a primeira opção de área de interesse, e também uma segunda opção. Vamos focar a sua aplicação na primeira área de interesse, mas também poderemos considerar a segunda opção antes da etapa de teste online.'
},
{
  intlKey: 'faq4',
  question: 'Quais são os critérios de elegibilidade para participar da primeira etapa?',
  answer: 'É necessário: <ul><li > • Ter matrícula ativa em um curso superior (bacharelado, licenciatura ou tecnólogo) em universidade brasileira, sem restrição de cursos;</li><li > • Previsão de formação na graduação entre dezembro de 2025 a julho de 2026; </li><li > • Inglês a partir do nível Intermediário; </li><li > • Disponibilidade para estagiar 30 horas semanais (6h dentro do horário comercial/dia) no Brasil entre Agosto de 2024 e Dezembro de 2025; </li><li>Morar no estado de São Paulo com disponibilidade para estagiar seguindo o modelo de trabalho híbrido do Nubank (Nu Way of Working)</li></ul >'
},
{
  intlKey: 'faq5',
  question: 'Não moro no Estado de São Paulo, mas estudo em uma instituição de ensino superior de São Paulo, posso participar do processo seletivo?',
  answer: 'Não. O trabalho seguirá o modelo de trabalho híbrido do Nubank, o Nu Way of Working. Para isso, as pessoas devem morar no estado de São Paulo com disponibilidade para estagiar, independentemente se a sua instituição de ensino está sediada na região. Para mais informações:  https://blog.nubank.com.br/nu-way-of-working/).'
},
{
  intlKey: 'faq6',
  question: 'Atualmente não moro no estado de  São Paulo, mas tenho flexibilidade e posso me mudar. Posso me inscrever?',
  answer: 'Não. Morar no estado de SP é um dos pré-requisitos do processo seletivo. Caso você não resida e não estude em São Paulo no momento da inscrição, e durante o período do programa, infelizmente não é possível participar desta edição do programa.'
},
{
  intlKey: 'faq7',
  question: 'Há restrição de cursos para participar?',
  answer: 'Não. Para se inscrever, basta ter matrícula ativa em qualquer curso superior (bacharelado, licenciatura ou tecnólogo) em universidade brasileira, com previsão de formação entre dezembro de 2025 e julho de 2026. Entretanto, vale ressaltar que a aprovação do contrato de estágio depende também do aceite da sua universidade/coordenação de curso. Confira as regras específicas do seu curso.'
},
{
  intlKey: 'faq8',
  question: 'Há alguma restrição com cursos EAD (Ensino a Distância)?',
  answer: 'Não. Cursos EAD também possuem registro e reconhecimento do MEC, por conta disso, não há restrição. O único critério é que a pessoa tenha previsão de formação entre dezembro de 2025 e julho de 2026.'
},
{
  intlKey: 'faq9',
  question: 'Há alguma restrição com cursos tecnólogos?',
  answer: 'Não. A lei 11.788 não apresenta restrições para cursos tecnólogos. Podem realizar estágio alunos regularmente matriculados e frequentes no ensino Técnico e Superior, com previsão de formação entre dezembro de 2025 e julho de 2026. Portanto, a regra da formação deverá ser determinada no alinhamento dos critérios de elegibilidade do programa.'
},
{
  intlKey: 'faq10',
  question: 'Estudo em uma universidade estrangeira, posso participar?',
  answer: 'Não. Todas as vagas deste processo seletivo são para pessoas vinculadas a instituições de ensino superior no Brasil.'
},
{
  intlKey: 'faq11',
  question: 'Como funciona a etapa de teste online?',
  answer: 'Será uma etapa com duração de 1 hora, em que você terá que resolver um problema de negócio. Não se preocupe, iremos enviar um email com todos os detalhes e possibilidades de dia/horários para que você possa se programar com bastante antecedência.'
},
{
  intlKey: 'faq12',
  question: 'Não recebi o teste online, o que eu faço?',
  answer: 'Os testes serão enviados por e-mail.  Atenção aos e-mails que são direcionados para o spam e à aba de promoções no seu email. Caso não tenha recebido após esta data, entre em contato pelo e-mail programadeestagio@nubank.com.br.'
},
{
  intlKey: 'faq13',
  question: 'Minha internet/energia caiu no meio do meu teste/meu computador travou na hora do teste/meu teste deu erro, o que eu faço?',
  answer: 'Por favor, entre em contato com programadeestagio@nubank.com.br para reportar o seu problema assim que conseguir. Entraremos em contato o mais rápido possível para explicar os próximos passos.'
},
{
  intlKey: 'faq14',
  question: 'Quando saberei se meu perfil foi aprovado entre as etapas?',
  answer: 'Enviaremos um email comunicando a sua aprovação ou não no final de cada fase e explicando os próximos passos. Os e-mails não são enviados ao mesmo tempo para todas as pessoas candidatas de nossos processos seletivos. Os dias e horários dos e-mails podem variar de acordo com a área selecionada.'
},
{
  intlKey: 'faq15',
  question: 'O processo terá alguma fase presencial?',
  answer: 'Não, todas as fases serão online.'
},
{
  intlKey: 'faq16',
  question: 'É necessário ter Inglês fluente para participar do processo?',
  answer: 'Não. Entretanto, procuramos pessoas com nível intermediário, uma vez que  o Nubank é uma empresa global com Nubankers de mais de 50 nacionalidades diferentes, e portanto o inglês é amplamente utilizado na comunicação entre diferentes equipes. Por isso, encorajamos o desenvolvimento e interesse pelo idioma. Sendo assim,  oferecemos também a todas as pessoas  selecionadas o NuLanguage, programa de inglês gratuito.'
},
{
  intlKey: 'faq17',
  question: 'Haverá alguma avaliação de Inglês?',
  answer: 'Não haverá prova de inglês. A única avaliação do idioma ocorrerá na entrevista final, com o time de RH, com uma pergunta em inglês para avaliar sua compreensão e comunicação em situações cotidianas do trabalho.'
},
{
  intlKey: 'faq18',
  question: 'Quais são as responsabilidades da pessoa que estagiar com Análise de Negócios?',
  answer: 'A pessoa apoiará o time responsável por: <ul><li >• Coletar, organizar e processar dados internos e externos para análise no Nubank; </li><li >• Estruturar problemas a partir de uma alta volumetria de dados;</li><li >• Identificar padrões, tendências e oportunidades de negócios a partir de experimentos;</li><li>• Propor melhorias nos processos e operações com base nos insights adquiridos.</li><li>• Desenvolver relatórios e painéis de controle para monitorar e comunicar os resultados das análises;</li><li>• Identificar e resolver problemas de negócios por meio da análise de dados;</li><li>• Definir métricas e indicadores de desempenho do negócio.</li></ul>'
},
{
  intlKey: 'faq19',
  question: 'Quais são as responsabilidades da pessoa que estagiar com Engenharia de Software?',
  answer: 'A pessoa apoiará o time responsável por:<ul><li >• Colaborar com equipes multidisciplinares para traduzir requisitos em soluções técnicas;</li><li >• Projetar e implementar arquiteturas escaláveis e eficientes; </li><li >• Atuar com sistemas de larga escala e distribuídos e  construção de microsserviços; </li><li >• Escrever código limpo, de fácil manutenção e seguindo as melhores práticas de desenvolvimento ágil;</li><li>• Participar ativamente na resolução de problemas complexos e desafios técnicos;</li><li>• Garantir a integração correta dos sistemas e a entrega de produtos de alta qualidade aos clientes.</li></ul>'
},
{
  intlKey: 'faq20',
  question: 'Quais são as responsabilidades da pessoa que estagiar com Ciência de Dados?',
  answer: 'A pessoa apoiará o time responsável por: <ul><li >• Coletar, organizar, limpar e analisar grandes volumes de dados no Nubank; </li><li >• Utilizar técnicas avançadas de modelagem estatística e aprendizado de máquina para extrair insights dos dados; </li><li >• Construir modelos preditivos e algoritmos que ajudam a prever comportamentos e riscos; </li><li >• Desenvolver ferramentas e pipelines de dados robustos e escaláveis; </li><li >• Avaliar e explorar novas técnicas, algoritmos e tecnologias de data science; </li><li >• Traduzir problemas de negócio em soluções de machine learning de e entregá-las.</ul>'
},
{
  intlKey: 'faq21',
  question: 'Qual o modelo de trabalho?',
  answer: 'Nosso modelo de trabalho é híbrido, o Nu Way of Working (ou "jeito Nu de trabalhar"), que funciona em ciclos que podem variar de dois a três meses de acordo com a unidade de negócio. Ou seja, para cada oito ou doze semanas de trabalho remoto, uma será no escritório (para mais informações: https://blog.nubank.com.br/nu-way-of-working/). Importante destacar que estadia e deslocamento não são custeados pelo Nubank.'
},
{
  intlKey: 'faq22',
  question: 'Qual o prazo de duração do estágio?',
  answer: 'O programa terá duração de 1 ano e 6 meses e contará com um plano de desenvolvimento durante todo o período.'
},
{
  intlKey: 'faq23',
  question: 'Quais são os benefícios do Programa de Estágio do Nubank?',
  answer: 'As pessoas estagiárias do Nubank recebem o seguinte plano de benefícios: <ul><li >• Cartão Alimentação/Refeição; </li><li >• Auxílio transporte;</li><li >• Plano de saúde, odontológico e seguro de vida; </li><li >• Onsite Health Center - Suporte médico para cada Nubanker em nosso escritório; </li><li >• NuCare - Nosso programa de assistência em saúde mental e bem-estar; </li><li>• Licença parental estendida;</li><li>• </li><li>• Programa de cuidados infantis e assistência parental;</li><li>• Núcleo - Nossa plataforma de aprendizagem de cursos</li><li>• NuLanguage - Nosso programa de aprendizado de idiomas</li><li>• Parcerias com academias.</li></ul>'
},
{
  intlKey: 'faq24',
  question: 'Qual o valor da bolsa auxílio?',
  answer: 'O valor da bolsa auxílio é compatível com o mercado e será compartilhado no final do processo seletivo, no momento da extensão da oferta com todos os benefícios detalhados que o Nubank oferece.'
},
{
  intlKey: 'faq25',
  question: 'Nos dias de prova poderá haver redução da jornada?',
  answer: 'De acordo com a Lei do Estágio, o estagiário tem o direito de reduzir sua carga horária pela metade nos períodos de avaliação/prova (art. 10, §2º).'
},
{
  intlKey: 'faq26',
  question: 'Qual a carga horária do Estágio?',
  answer: 'É importante que, ao longo do programa, haja disponibilidade para cumprir 30h semanais de estágio, contando com flexibilidade para adequar às atividades acadêmicas.'
},{
  intlKey: 'faq27',
  question: 'Quando as pessoas aprovadas começarão o estágio no Nubank?',
  answer: 'A previsão para início do estágio é Agosto de 2024.'
},
{
  intlKey: 'faq28',
  question: 'Caso eu tenha outras dúvidas, o que devo fazer?',
  answer: 'Em caso de dúvidas, escreva para o nosso time de recrutamento através do e-mail programadeestagio@nubank.com.br'
}


];

var stringToHTML = function (str) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(str, 'text/html');
  return doc.body;
}
var parser = new DOMParser();

class SectionFAQ extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <Grid
        row
        id="faq"
        tag="section"
        spacingHorizontal={{
          xs: '2x',
          md: '4x',
          lg: '6x',
          }}
          spacingTop={{ xs: '16x', md: '16x', lg: '16x' }}
          >
          <Grid
            col={{ xs: 12, lg: 10 }}
            offset={{ lg: 1 }}
            Top={{ xs: '6x', lg: '8x' }}
            >
            <Typography
              variant="heading3"
              color="black"
              colorVariant="default"
              gutterBottom={2}
              >
              Perguntas Frequentes
            </Typography>
          </Grid>


          {questions.map(question => (
            // <div >
            <Grid
              key={question.intlKey}
              col={{ xs: 12, lg: 10 }}
              offset={{ lg: 1 }}
              spacingVertical={{ xs: '6x', lg: '8x' }}
              >
              <Box
                gridGap={{
                  sm: '20px',
                  md: '1em',
                  lg: '20px'
                  }}>
                  <Collapse>
                    <Collapse.Header>
                      <Typography
                        variant="heading4"
                        color="black"
                        colorVariant="light"
                        >
                        {question.question}
                      </Typography>
                    </Collapse.Header>

                    <Collapse.Body>
                      <Typography
                        id={question.intlKey}
                        variant="paragraph1"
                        color="black"
                        colorVariant="light"
                        intlValues={{
                          strong: (...text) => (
                            <Typography
                              tag="span"
                              variant="subtitle1"
                              strong
                              >
                              {text}
                              </Typography>
                              ),
                          }}
                          >
                          { ReactHtmlParser (question.answer) } 
                          
                        </Typography>
                      </Collapse.Body>
                    </Collapse>
                  </Box>
                  </Grid>
                // </div>
                  ))}
          </Grid>
          );
  }
}

export default SectionFAQ;
